// extracted by mini-css-extract-plugin
export default {"singin":"sign-in_singin__jOTCl","logo":"sign-in_logo__AR3Fw","button":"sign-in_button__GiN5Z","forgotPassword":"sign-in_forgotPassword__o1AaN","footer":"sign-in_footer__Fif+Q"};